import styled from 'styled-components';

const CourseMaterialsItemWrapper = styled.div``;

CourseMaterialsItemWrapper.displayName = 'CourseMaterialsItemWrapper';

export default CourseMaterialsItemWrapper;
